module.exports = __webpack_public_path__ + "img/Chicago_neighborhoods_map.f78495f4.png";